// Date 2022-07-08 14:26:47

import sithMesTpmOperateModeTomList from "@/views/sithMes/tpm/SithMesTpmOperateModeTomList.vue";
import sithMesTpmOperateModeTomEdit from "@/views/sithMes/tpm/SithMesTpmOperateModeTomEdit.vue";
import sithMesTpmProgramStatusTpsList from "@/views/sithMes/tpm/SithMesTpmProgramStatusTpsList.vue";
import sithMesTpmProgramStatusTpsEdit from "@/views/sithMes/tpm/SithMesTpmProgramStatusTpsEdit.vue";
import sithMesTpmProcessDataTpdList from "@/views/sithMes/tpm/SithMesTpmProcessDataTpdList.vue";
import sithMesTpmProcessDataTpdEdit from "@/views/sithMes/tpm/SithMesTpmProcessDataTpdEdit.vue";
import sithMesTpmSpindleDataTsdEdit from "@/views/sithMes/tpm/SithMesTpmSpindleDataTsdEdit.vue";
import sithMesTpmSpindleDataTsdList from "@/views/sithMes/tpm/SithMesTpmSpindleDataTsdList.vue";
import sithMesTpmAxisDataTadList from "@/views/sithMes/tpm/SithMesTpmAxisDataTadList.vue";
import sithMesTpmAxisDataTadEdit from "@/views/sithMes/tpm/SithMesTpmAxisDataTadEdit.vue";
import sithMesTpmTsdOpcConfigTtcList from "@/views/sithMes/tpm/SithMesTpmTsdOpcConfigTtcList.vue";
import sithMesTpmTsdOpcConfigTtcEdit from "@/views/sithMes/tpm/SithMesTpmTsdOpcConfigTtcEdit.vue";
import sithMesTpmWarningDataTwdEdit from "@/views/sithMes/tpm/SithMesTpmWarningDataTwdEdit.vue";
import sithMesTpmWarningDataTwdList from "@/views/sithMes/tpm/SithMesTpmWarningDataTwdList.vue";
import sithMesTpmSpindleDataTsdListNew from "@/views/sithMes/tpm/SithMesTpmSpindleDataTsdListNew";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
//自定义页面注册
    {
        path: "/sithMes/tpm/sithMesTpmOperateModeTomList",
        name: "sithMesTpmOperateModeTomList",
        component: sithMesTpmOperateModeTomList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/tpm/sithMesTpmOperateModeTomEdit",
        name: "sithMesTpmOperateModeTomEdit",
        component: sithMesTpmOperateModeTomEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/tpm/sithMesTpmProgramStatusTpsList",
        name: "sithMesTpmProgramStatusTpsList",
        component: sithMesTpmProgramStatusTpsList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/tpm/sithMesTpmProgramStatusTpsEdit",
        name: "sithMesTpmProgramStatusTpsEdit",
        component: sithMesTpmProgramStatusTpsEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/tpm/sithMesTpmProcessDataTpdList",
        name: "sithMesTpmProcessDataTpdList",
        component: sithMesTpmProcessDataTpdList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/tpm/sithMesTpmProcessDataTpdEdit",
        name: "sithMesTpmProcessDataTpdEdit",
        component: sithMesTpmProcessDataTpdEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/tpm/sithMesTpmSpindleDataTsdEdit",
        name: "sithMesTpmSpindleDataTsdEdit",
        component: sithMesTpmSpindleDataTsdEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/tpm/sithMesTpmSpindleDataTsdList",
        name: "sithMesTpmSpindleDataTsdList",
        component: sithMesTpmSpindleDataTsdList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/tpm/sithMesTpmSpindleDataTsdListNew",
        name: "sithMesTpmSpindleDataTsdListNew",
        component: sithMesTpmSpindleDataTsdListNew,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/tpm/sithMesTpmAxisDataTadList",
        name: "sithMesTpmAxisDataTadList",
        component: sithMesTpmAxisDataTadList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/tpm/sithMesTpmAxisDataTadEdit",
        name: "sithMesTpmAxisDataTadEdit",
        component: sithMesTpmAxisDataTadEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/tpm/sithMesTpmTsdOpcConfigTtcList",
        name: "sithMesTpmTsdOpcConfigTtcList",
        component: sithMesTpmTsdOpcConfigTtcList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/tpm/sithMesTpmTsdOpcConfigTtcEdit",
        name: "sithMesTpmTsdOpcConfigTtcEdit",
        component: sithMesTpmTsdOpcConfigTtcEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/tpm/sithMesTpmWarningDataTwdEdit",
        name: "sithMesTpmWarningDataTwdEdit",
        component: sithMesTpmWarningDataTwdEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/tpm/sithMesTpmWarningDataTwdList",
        name: "sithMesTpmWarningDataTwdList",
        component: sithMesTpmWarningDataTwdList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    }
]